export { default } from './text-page-content'
